import { CompanyContactId, SuretyAccountId } from "@inrev/common";
import { useDownloadFileBuffer } from "../../../api";

export const useGetAccountBondabilityLetter = (accountId: SuretyAccountId) => {
	const fileBufferQuery = useDownloadFileBuffer();

	const getBondabilityLetter = (companyContactId: CompanyContactId) => {
		return fileBufferQuery(
			`/v2/surety/accounts/${accountId}/bondability-letter/${companyContactId}`,
			"bondability-letter.pdf",
			["accountBondabilityLetter", accountId, companyContactId],
		);
	};

	return getBondabilityLetter;
};
